import { ReactNode } from "react";
import { ArrowUpRight } from "lucide-react";

interface ContactCardProps {
  icon: ReactNode;
  title: string | ReactNode;
  onClick?: () => void;
}

export default function ContactCard({ icon, title, onClick }: ContactCardProps) {
  return (
    <div className="relative flex flex-col items-center gap-3 flex-1 min-w-[250px] px-5 py-6 md:py-8 border border-gray-200 bg-white shadow-lg hover:shadow-xl transition-all duration-300">
      {/* Icon Container */}
      <div className="flex items-center justify-center">
        {icon}
      </div>

      {/* Title */}
      <div className="w-full text-center text-[var(--color-secondary)] font-montserrat text-lg md:text-[16px] font-semibold leading-[150%]">
        {title}
      </div>

      {/* Arrow Icon */}
      <button 
        onClick={onClick}
        className="absolute top-5 right-5 hover:opacity-80 transition-opacity"
        aria-label="Open link"
      >
        <ArrowUpRight className="w-8 h-8 md:w-9 md:h-9" strokeWidth={1} color="#9ca3af" />
      </button>
    </div>
  );
}

